import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PropertyListingFilter from './pages/PropertyListingFilter';
import PropertyDetails from './pages/PropertyDetails';
import NavigatorOnly from './pages/NavigatorOnly';
import { SearchProvider } from './contexts/SearchContext';
import { WidgetEventProvider } from './contexts/WidgetEventContext';
import { useIframeHeightSync } from './hooks/useIframeHeightSync';
import { useUrlEventDispatch } from './hooks/useUrlEventDispatch';
import { useWidgetCommandBus } from './hooks/useWidgetCommandBus';
import './App.css';

function EventBusBridge() {
  useUrlEventDispatch();
  useWidgetCommandBus();
  return null;
}

function App() {
  // Iframe height sync (no-op outside iframe).
  useIframeHeightSync();

  return (
    <SearchProvider>
      <WidgetEventProvider>
        <Router>
          <EventBusBridge />
          <div className="App">
            <Routes>
              <Route path="/" element={<PropertyListingFilter />} />
              <Route path="/navigator" element={<NavigatorOnly />} />
              <Route path="/properties/:id" element={<PropertyDetails />} />
            </Routes>
          </div>
        </Router>
      </WidgetEventProvider>
    </SearchProvider>
  );
}

export default App;
